<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2024-11-14 14:38:18
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2024-11-26 16:42:47
 * @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-mall/pages/user/user/order/components/orderMap.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 地图展示 -->
<template>
  <div>
    <div class="map-container map-info">
      <div class="detail-title margin-b10" style="margin-left: 20px">
        配送方式<span class="des-title">{{
          deliveryInfo.deliveryWay == 0 ? '(自行配送)' : '(第三方物流配送)'
        }}</span>
      </div>
      <el-form label-width="120px">
        <el-row>
          <el-col :span="12" style="height: 30px">
            <el-form-item label="物流公司：" prop="pass">
              {{ deliveryInfo.expressCompanyName }}
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 30px">
            <el-form-item label="物流单号：">{{
              deliveryInfo.logisticsNo
            }}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="min-height: 30px">
            <el-form-item label="附件:" prop="pass">
              <div class="flex">
                <div
                  v-for="(item, index) in receiveOrderData.listAttachment"
                  :key="index"
                  class="bill"
                >
                  <a
                    :href="item.attachmentUrl"
                    :download="item.attachmentName"
                    class="notice"
                    >{{ item.attachmentName }}</a
                  >
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="map-container map-img">
      <div class="detail-title margin-b10" style="margin-left: 20px">
        物流信息
      </div>
      <div>
        <iframe
          :src="ewuliuMapUrl"
          frameborder="0"
          style="width: 100%; height: 450px; overflow-y: auto"
        ></iframe>
      </div>
      <div class="tip-wrap">
        <div class="red">提示：</div>
        <div class="content">
          <p>
            易派客平台仅作为物流相关信息的展示方，提供物流数据展示服务，具体运输商资质、物流合同洽谈与签署、物流报价、物流时效、违约等有关
          </p>
          <p>物流实际运作相关的信息与事项，请您与您的合作运输商沟通确认。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    ewuliuMapUrl: {
      type: String,
      default: '',
    },
    deliveryInfo: {
      type: Object,
      default: () => {},
    },
    receiveOrderData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },

  computed: {},

  created() {
    console.log(this.receiveOrderData, 'sub');
  },
  methods: {
    // 处理文件名称过长问题
    dealAttachmentName(attachmentName) {
      if (attachmentName.length > 10) {
        const preName = attachmentName.substr(0, 3);
        const lastName = attachmentName.substring(
          attachmentName.lastIndexOf('.') - 2
        );
        return `${preName}...${lastName}`;
      }
      return attachmentName;
    },
  },
};
</script>
<style lang="scss" scoped>
.map-container {
  width: 100%;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  // margin-left: 10px;
  padding: 14px 20px 20px 0;
  margin-top: 10px;
}
.detail-title {
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}
.tip-wrap {
  display: flex;
  background-color: #e8efff;
  padding: 10px 20px;
  margin-top: 10px;
  margin-left: 20px;
  .red {
    color: #ef4c56;
    display: inline-block;
  }
}
.bill {
  margin-right: 10px;
  .notice {
    cursor: pointer;
    color: #0064c8;
  }
}
.flex {
  flex-flow: wrap;
}
</style>
